<template>
  <div class="experience" :style="cssVariables">
    <timeline :source="items" :text-color="textColor" :stack-color="stackColor" :bullet-color="bulletColor">
      <template v-slot:description="slotProps">
        <p class="timeline--experience__company">{{ slotProps.item.company }}</p>
        <p class="timeline--experience__location">{{ slotProps.item.location }}</p>
      </template>
    </timeline>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

import Timeline from '@/components/Timeline'

export default {

  props: {
    source: {
      type: [String, Array],
      required: true
    },
    textColor: {
      type: String,
      default: '#ffffff'
    },
    stackColor: {
      type: String,
      default: '#ffffff'
    },
    bulletColor: {
      type: String,
      default: 'transparent'
    }
  },

  components: {
    'timeline': Timeline
  },

  data () {
    return {
      items: []
    }
  },

  mounted () {
    this.fetchData()
  },

  computed: {
    ...mapState(['$works']),

    cssVariables () {
      return {
        '--text-color': this.textColor
      }
    }
  },

  methods: {
    ...mapMutations(['increase$loading', 'decrease$loading']),

    fetchData () {
      if (typeof this.source === 'string') {
        /* this.increase$loading()
        fetch(this.source)
          .then(stream => stream.json())
          .then(data => (this.items = data))
          .then(() => { this.decrease$loading() })
          .catch(error => { this.decrease$loading(); console.error(error) }) */
        this.items = this.$works
      } else {
        this.items = this.source
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.timeline--experience {
  &__company {
    font-size: 1rem;
    font-weight: 300;
    color: var(--text-color);
  }
  &__location {
    font-size: 1rem;
    font-weight: 300;
    font-style: italic;
    color: var(--text-color);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Experience.vue